import styled from 'styled-components';

export default styled.div`
  width: 100%;

  .custom-tooltip {
    min-width: 260px;
    padding: var(--size) 12px;
    
    .table {
      margin-top: 5px;
      margin-bottom: 0px;

      .subjects {
        width: 100px;
      }

      .report {
        flex: 1;
      }

      .table-header {
        display: flex;
        gap: 4px;
        flex-direction: row;
        border-bottom: 1px solid #CCCCCC;

        label {
          color: var(--color-primary-70);
          font-size: 11px;
        }
      }

      .item {
        gap: 4px;
        display: flex;
        padding: 10px 0px;
        border-bottom: 1px solid #CCCCCC;

        .subjects { 
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        label {
          margin-bottom: 0px;
        }

        .progress-cont {
          display: flex;
          gap: 8px;

          .progress { 
            display: flex;
            flex: 1;
            height: 10px;
            background: #F4F4F4;
            width: 100px;
            display: flex;
          }

          label {
            width: 30px;
            text-align: right;
          }
        }
      }
    }

    .label {
      font-size: 14px;
      font-weight: 700;
      margin-bottom: 12px;
      color: #001529;
    }

    .value {
      display: flex;

      label {
        margin-bottom: 0px;
        font-size: 12px;
      }

      .title {
        font-weight: 500;
        width: 160px;
      }

      .percentage {
        color: var(--color-primary-70);
        font-weight: 700;
      }
    }
  }

  .legend {
    margin-left: 38px;
    display: flex;
    margin-top: -10px;
    gap: 4px;

    .item {
      padding-top: 10px;
      display: flex;
      flex-direction: column;
      gap: 6px;
      flex: 1;
      overflow: hidden;

      &.disabled {
        opacity: 0.5;
      }

      &.active {
        svg {
          fill: var(--color-primary-70);
        }

        button {
          border-color: var(--color-primary-70);
        }
      }

      .section {
        display: flex;
        justify-content: center;
        overflow: hidden;

        svg {
          margin-top: -5px;
        }

        label {
          white-space: no-wrap;
          font-size: 11px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: #414141;
          font-weight: 600;
          margin-bottom: 0px;
        }
      }
    }
  }
`;
